import PlusIcon from './component'

export default PlusIcon
